import { memo } from 'react'

import {
  MAX_MILES_EXCHANGE_ACCOUNT_NUMBER_INPUT_LENGTH,
  MAX_POINTS_EXCHANGE_ACCOUNT_NUMBER_INPUT_LENGTH
} from 'src/constants/app'
import { exchangeProviderAccountLabel } from '../../util/pointsExchange.helpers'
import CustomTextField from '../shared/inputs/CustomTextField'

const ConnectAccountField = ({
  provider,
  value,
  error,
  qrCodeEnabled,
  onQrCodeClick,
  onChange,
  t,
  disabled
}) => {
  return (
    <>
      <CustomTextField
        label={exchangeProviderAccountLabel(t, provider)}
        value={value}
        error={error}
        onChange={onChange}
        size='default'
        qrCodeEnabled={qrCodeEnabled}
        onQrCodeClick={onQrCodeClick}
        multiLine={!(provider?.isMiles || provider?.isCrypto)}
        maxLength={
          provider?.isMiles
            ? MAX_MILES_EXCHANGE_ACCOUNT_NUMBER_INPUT_LENGTH
            : MAX_POINTS_EXCHANGE_ACCOUNT_NUMBER_INPUT_LENGTH
        }
        disabled={disabled}
      />
    </>
  )
}

export default memo(ConnectAccountField)
